import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasSelectMilkMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('SELECTMILK_MEMBER_CENTER');
    }
}
